/**
 * The version of the deploy serving this page.
 *
 * Substituted by Vite's `define` (see vite.config.ts). Declaring the global here rather than
 * in an ambient .d.ts keeps it scoped to the one module that is allowed to read it.
 */
declare const __BUILD_VERSION__: string;

export const BUILD_VERSION = __BUILD_VERSION__;
